import { Tag } from 'antd'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles, useTheme } from 'react-jss'
import api from '../../api'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 8,
  },
  tag: {
    borderRadius: 6,
    fontSize: 13,
    padding: '4px 12px',
    lineHeight: '20px',
    border: '1px solid #e8e8e8',
    background: '#fafafa',
    color: ({ theme }) => theme.textColor,
    margin: 0,
  },
  empty: {
    color: ({ theme }) => theme.textGrayColor,
    fontSize: 13,
    fontStyle: 'italic',
  },
})

export default function DiseasesList({ patientId }) {
  const [diseases, setDiseases] = useState([])
  const theme = useTheme()
  const classes = useStyles({ theme })

  useEffect(() => {
    api.diseases
      .getDiseases(patientId)
      .then(data =>
        setDiseases(data.sort((a, b) => a.name.localeCompare(b.name))),
      )
  }, [patientId])

  if (diseases.length === 0) {
    return <span className={classes.empty}>No diseases recorded</span>
  }

  return (
    <div className={classes.container}>
      {diseases.map(disease => (
        <Tag key={disease.id} className={classes.tag}>
          {disease.name}
        </Tag>
      ))}
    </div>
  )
}

DiseasesList.propTypes = {
  patientId: PropTypes.string.isRequired,
}
